<template>
  <div class="medias">
    <div class="banner">
      <div class="banner-warpper">
        <div class="container">
          <div class="banner-text">
            <h2>新闻动态</h2>
            <span class="subtitle"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="subcolumn">
      <div class="container">
        <div class="row">
          <div class="clearfix">
            <div class="subcolumn-nav">
              <ul class="subcolumn_nav_ul">
                <li>
                  <a
                    href="javascript:;"
                    title="全部"
                    target="_self"
                    :class="`${tag==='ALL'?'active':''} link changeTag`"
                    @click="changeTag('ALL')"
                  >全部</a>
                </li>
                <li>
                  <a
                    href="javascript:;"
                    title="公司动态"
                    target="_self"
                    :class="`${tag==='ec'?'active':''} link changeTag`"
                    @click="changeTag('ec')"
                  >公司动态</a>
                </li>
                <li>
                  <a
                    href="javascript:;"
                    title="赛事资讯"
                    target="_self"
                    :class="`${tag==='match'?'active':''} link changeTag`"
                    @click="changeTag('match')"
                  >赛事资讯</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="medias_centent">
      <div class="container">
        <div class="row">
          <div class="news_list">
            <ul>
              <li v-for="(item,index) in news" :key="index" class="media">
                <div class="left col-lg-3">
                  <a :href="item.link" :title="item.title" target="_blank">
                    <img class="img-fluid" :src="item.cover" :alt="item.title" style />
                  </a>
                </div>
                <div class="right col-lg-9">
                  <h4
                    class="animation-delay-200 appear-no-repeat animation-slide-bottom"
                    data-repeat="false"
                  >
                    <a :href="item.link" :title="item.title" target="_blank">
                      <span style>{{item.title}}</span>
                    </a>
                  </h4>
                  <div class="clearfix">
                    <p
                      class="des animation-delay-300 appear-no-repeat animation-slide-bottom"
                      data-repeat="false"
                    >{{item.summary}}</p>
                    <a
                      :href="item.link"
                      target="_blank"
                      class="more animation-delay-400 appear-no-repeat animation-slide-bottom"
                      data-repeat="false"
                    >
                      <span data-title="查看详情">查看详情</span>
                    </a>
                  </div>
                  <p
                    class="info font-weight-300 animation-delay-500 appear-no-repeat animation-slide-bottom"
                    data-repeat="false"
                  >
                    <span>{{item.createtime|dateTime}}</span>
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="news_pager">
        <nav>
          <ul class="pager">
            <li v-if="page>1">
              <a href="javascript:;" class="pre" @click="page--">上一页</a>
            </li>
            <li v-if="canloadMore">
              <a href="javascript:;" class="next" @click="page++">下一页</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "underscore";
export default {
  data() {
    return {
      canloadMore: false,
      news: [],
      tag: "ALL",
      page: 1,
    };
  },
  watch: {
    page() {
      this.getdata();
    },
  },
  methods: {
    getdata() {
      this.$api
        .post("/wapi", {
          method: "ssy-app/media/getList",
          data: {
            page: this.page,
            limit: 10,
            tag: this.tag,
          },
        })
        .then((res) => {
          if (res.code !== 0) return;
          this.canloadMore = res.data.canloadMore;
          this.news = res.data.data;
        })
        .catch((err) => {});
    },
    changeTag(tag) {
      if (tag !== this.tag) {
        this.tag = tag;
        if (this.page === 1) this.getdata();
        else this.page = 1;
      }
    },
  },
  mounted() {
    this.getdata();
  },
};
</script>